import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { tap, map, catchError } from 'rxjs/operators';

@Injectable()
export class HttpService {

  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  loginUser(datas): Observable<any> {
    const url = this.baseUrl + 'signin';
    return this.http.post(url, JSON.stringify(datas)).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  getNewAccessToken(token): Observable<any> {
    const url = this.baseUrl + 'renew_token';
    return this.http.post(url, {
      refresh_token: token
    }).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  getInfoSocial(): Observable<any> {
    const url = this.baseUrl + 'social_app';
    return this.http.get(url).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  loginSocial(type, token): Observable<any> {
    const url = this.baseUrl + 'signin';
    return this.http.post(url, {
      type: type,
      access_token: token
    }).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  getQuietAreas(lang): Observable<any> {
    const url = this.baseUrl + 'group_area?lang=' + lang;
    return this.http.get(url).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  getQuestion(id, lang): Observable<any> {
    const url = this.baseUrl + 'question_detail?data_id=' + id + '&lang=' + lang;
    return this.http.get(url).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  filterArea(noise, descriptors, quietness, visual, accessibility, timeframe, lang): Observable<any> {
    const url = this.baseUrl +
      'filter_area?noise=' + noise +
      '&descriptors=' + descriptors +
      '&quietness=' + quietness +
      '&visual_quality=' + visual +
      '&accessibility=' + accessibility +
      '&timeframe=' + timeframe +
      '&lang=' + lang;
    return this.http.get(url).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  getAmbassadors(): Observable<any> {
    const url = this.baseUrl + 'contributors';
    return this.http.get(url).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  sendFeedback(feedback): Observable<any> {
    const url = this.baseUrl + 'submit_feedback';
    return this.http.post(url, feedback).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  extractFile(extract): Observable<any> {
    const url = this.baseUrl + 'extract_data';
    return this.http.post(url, extract).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  extractCustom(token, type): Observable<any> {
    const url = this.baseUrl + 'extract_' + type + '?access_token=' + token;
    return this.http.get(url).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

  deleteData(del): Observable<any> {
    const url = this.baseUrl + 'delete_data';
    return this.http.post(url, del).pipe(
      tap(
        data => data,
        error => console.log(error)
      ),
      catchError(error => of())
    );
  }

}
